import * as React from 'react';
import styles from './index.module.scss';

const Footer = () => {
  return <footer className={styles.footer}><a target="_blank" href="https://beian.miit.gov.cn/">蜀ICP备2022007945号-1</a></footer>;
};

export default Footer;
